/*
File generated by js-routes 1.4.9
Based on Rails 5.2.8.1 routes of BradsDeals3::Application
 */

(function() {
  var DeprecatedGlobbingBehavior, NodeTypes, ParameterMissing, ReservedOptions, SpecialOptionsKey, UriEncoderSegmentRegex, Utils, result, root,
    hasProp = {}.hasOwnProperty,
    slice = [].slice;

  root = typeof exports !== "undefined" && exports !== null ? exports : this;

  ParameterMissing = function(message, fileName, lineNumber) {
    var instance;
    instance = new Error(message, fileName, lineNumber);
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(instance, Object.getPrototypeOf(this));
    } else {
      instance.__proto__ = this.__proto__;
    }
    if (Error.captureStackTrace) {
      Error.captureStackTrace(instance, ParameterMissing);
    }
    return instance;
  };

  ParameterMissing.prototype = Object.create(Error.prototype, {
    constructor: {
      value: Error,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ParameterMissing, Error);
  } else {
    ParameterMissing.__proto__ = Error;
  }

  NodeTypes = {"GROUP":1,"CAT":2,"SYMBOL":3,"OR":4,"STAR":5,"LITERAL":6,"SLASH":7,"DOT":8};

  DeprecatedGlobbingBehavior = false;

  SpecialOptionsKey = "_options";

  UriEncoderSegmentRegex = /[^a-zA-Z0-9\-\._~!\$&'\(\)\*\+,;=:@]/g;

  ReservedOptions = ['anchor', 'trailing_slash', 'subdomain', 'host', 'port', 'protocol'];

  Utils = {
    configuration: {
      prefix: "",
      default_url_options: {},
      special_options_key: "_options",
      serializer: null
    },
    default_serializer: function(object, prefix) {
      var element, i, j, key, len, prop, s;
      if (prefix == null) {
        prefix = null;
      }
      if (object == null) {
        return "";
      }
      if (!prefix && !(this.get_object_type(object) === "object")) {
        throw new Error("Url parameters should be a javascript hash");
      }
      s = [];
      switch (this.get_object_type(object)) {
        case "array":
          for (i = j = 0, len = object.length; j < len; i = ++j) {
            element = object[i];
            s.push(this.default_serializer(element, prefix + "[]"));
          }
          break;
        case "object":
          for (key in object) {
            if (!hasProp.call(object, key)) continue;
            prop = object[key];
            if ((prop == null) && (prefix != null)) {
              prop = "";
            }
            if (prop != null) {
              if (prefix != null) {
                key = prefix + "[" + key + "]";
              }
              s.push(this.default_serializer(prop, key));
            }
          }
          break;
        default:
          if (object != null) {
            s.push((encodeURIComponent(prefix.toString())) + "=" + (encodeURIComponent(object.toString())));
          }
      }
      if (!s.length) {
        return "";
      }
      return s.join("&");
    },
    serialize: function(object) {
      var custom_serializer;
      custom_serializer = this.configuration.serializer;
      if ((custom_serializer != null) && this.get_object_type(custom_serializer) === "function") {
        return custom_serializer(object);
      } else {
        return this.default_serializer(object);
      }
    },
    clean_path: function(path) {
      var last_index;
      path = path.split("://");
      last_index = path.length - 1;
      path[last_index] = path[last_index].replace(/\/+/g, "/");
      return path.join("://");
    },
    extract_options: function(number_of_params, args) {
      var last_el, options;
      last_el = args[args.length - 1];
      if ((args.length > number_of_params && last_el === void 0) || ((last_el != null) && "object" === this.get_object_type(last_el) && !this.looks_like_serialized_model(last_el))) {
        options = args.pop() || {};
        delete options[this.configuration.special_options_key];
        return options;
      } else {
        return {};
      }
    },
    looks_like_serialized_model: function(object) {
      return !object[this.configuration.special_options_key] && ("id" in object || "to_param" in object);
    },
    path_identifier: function(object) {
      var property;
      if (object === 0) {
        return "0";
      }
      if (!object) {
        return "";
      }
      property = object;
      if (this.get_object_type(object) === "object") {
        if ("to_param" in object) {
          if (object.to_param == null) {
            throw new ParameterMissing("Route parameter missing: to_param");
          }
          property = object.to_param;
        } else if ("id" in object) {
          if (object.id == null) {
            throw new ParameterMissing("Route parameter missing: id");
          }
          property = object.id;
        } else {
          property = object;
        }
        if (this.get_object_type(property) === "function") {
          property = property.call(object);
        }
      }
      return property.toString();
    },
    clone: function(obj) {
      var attr, copy, key;
      if ((obj == null) || "object" !== this.get_object_type(obj)) {
        return obj;
      }
      copy = obj.constructor();
      for (key in obj) {
        if (!hasProp.call(obj, key)) continue;
        attr = obj[key];
        copy[key] = attr;
      }
      return copy;
    },
    merge: function() {
      var tap, xs;
      xs = 1 <= arguments.length ? slice.call(arguments, 0) : [];
      tap = function(o, fn) {
        fn(o);
        return o;
      };
      if ((xs != null ? xs.length : void 0) > 0) {
        return tap({}, function(m) {
          var j, k, len, results, v, x;
          results = [];
          for (j = 0, len = xs.length; j < len; j++) {
            x = xs[j];
            results.push((function() {
              var results1;
              results1 = [];
              for (k in x) {
                v = x[k];
                results1.push(m[k] = v);
              }
              return results1;
            })());
          }
          return results;
        });
      }
    },
    normalize_options: function(parts, required_parts, default_options, actual_parameters) {
      var i, j, key, len, options, part, parts_options, result, route_parts, url_parameters, use_all_parts, value;
      options = this.extract_options(parts.length, actual_parameters);
      if (actual_parameters.length > parts.length) {
        throw new Error("Too many parameters provided for path");
      }
      use_all_parts = actual_parameters.length > required_parts.length;
      parts_options = {};
      for (key in options) {
        if (!hasProp.call(options, key)) continue;
        use_all_parts = true;
        if (this.indexOf(parts, key) >= 0) {
          parts_options[key] = value;
        }
      }
      options = this.merge(this.configuration.default_url_options, default_options, options);
      result = {};
      url_parameters = {};
      result['url_parameters'] = url_parameters;
      for (key in options) {
        if (!hasProp.call(options, key)) continue;
        value = options[key];
        if (this.indexOf(ReservedOptions, key) >= 0) {
          result[key] = value;
        } else {
          url_parameters[key] = value;
        }
      }
      route_parts = use_all_parts ? parts : required_parts;
      i = 0;
      for (j = 0, len = route_parts.length; j < len; j++) {
        part = route_parts[j];
        if (i < actual_parameters.length) {
          if (!parts_options.hasOwnProperty(part)) {
            url_parameters[part] = actual_parameters[i];
            ++i;
          }
        }
      }
      return result;
    },
    build_route: function(parts, required_parts, default_options, route, full_url, args) {
      var options, parameters, result, url, url_params;
      args = Array.prototype.slice.call(args);
      options = this.normalize_options(parts, required_parts, default_options, args);
      parameters = options['url_parameters'];
      result = "" + (this.get_prefix()) + (this.visit(route, parameters));
      url = Utils.clean_path(result);
      if (options['trailing_slash'] === true) {
        url = url.replace(/(.*?)[\/]?$/, "$1/");
      }
      if ((url_params = this.serialize(parameters)).length) {
        url += "?" + url_params;
      }
      url += options.anchor ? "#" + options.anchor : "";
      if (full_url) {
        url = this.route_url(options) + url;
      }
      return url;
    },
    visit: function(route, parameters, optional) {
      var left, left_part, right, right_part, type, value;
      if (optional == null) {
        optional = false;
      }
      type = route[0], left = route[1], right = route[2];
      switch (type) {
        case NodeTypes.GROUP:
          return this.visit(left, parameters, true);
        case NodeTypes.STAR:
          return this.visit_globbing(left, parameters, true);
        case NodeTypes.LITERAL:
        case NodeTypes.SLASH:
        case NodeTypes.DOT:
          return left;
        case NodeTypes.CAT:
          left_part = this.visit(left, parameters, optional);
          right_part = this.visit(right, parameters, optional);
          if (optional && ((this.is_optional_node(left[0]) && !left_part) || ((this.is_optional_node(right[0])) && !right_part))) {
            return "";
          }
          return "" + left_part + right_part;
        case NodeTypes.SYMBOL:
          value = parameters[left];
          delete parameters[left];
          if (value != null) {
            return this.encode_segment(this.path_identifier(value));
          }
          if (optional) {
            return "";
          } else {
            throw new ParameterMissing("Route parameter missing: " + left);
          }
          break;
        default:
          throw new Error("Unknown Rails node type");
      }
    },
    encode_segment: function(segment) {
      return segment.replace(UriEncoderSegmentRegex, function(str) {
        return encodeURIComponent(str);
      });
    },
    is_optional_node: function(node) {
      return this.indexOf([NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT], node) >= 0;
    },
    build_path_spec: function(route, wildcard) {
      var left, right, type;
      if (wildcard == null) {
        wildcard = false;
      }
      type = route[0], left = route[1], right = route[2];
      switch (type) {
        case NodeTypes.GROUP:
          return "(" + (this.build_path_spec(left)) + ")";
        case NodeTypes.CAT:
          return "" + (this.build_path_spec(left)) + (this.build_path_spec(right));
        case NodeTypes.STAR:
          return this.build_path_spec(left, true);
        case NodeTypes.SYMBOL:
          if (wildcard === true) {
            return "" + (left[0] === '*' ? '' : '*') + left;
          } else {
            return ":" + left;
          }
          break;
        case NodeTypes.SLASH:
        case NodeTypes.DOT:
        case NodeTypes.LITERAL:
          return left;
        default:
          throw new Error("Unknown Rails node type");
      }
    },
    visit_globbing: function(route, parameters, optional) {
      var left, right, type, value;
      type = route[0], left = route[1], right = route[2];
      value = parameters[left];
      delete parameters[left];
      if (value == null) {
        return this.visit(route, parameters, optional);
      }
      value = (function() {
        switch (this.get_object_type(value)) {
          case "array":
            return value.join("/");
          default:
            return value;
        }
      }).call(this);
      if (DeprecatedGlobbingBehavior) {
        return this.path_identifier(value);
      } else {
        return encodeURI(this.path_identifier(value));
      }
    },
    get_prefix: function() {
      var prefix;
      prefix = this.configuration.prefix;
      if (prefix !== "") {
        prefix = (prefix.match("/$") ? prefix : prefix + "/");
      }
      return prefix;
    },
    route: function(parts_table, default_options, route_spec, full_url) {
      var j, len, part, parts, path_fn, ref, required, required_parts;
      required_parts = [];
      parts = [];
      for (j = 0, len = parts_table.length; j < len; j++) {
        ref = parts_table[j], part = ref[0], required = ref[1];
        parts.push(part);
        if (required) {
          required_parts.push(part);
        }
      }
      path_fn = function() {
        return Utils.build_route(parts, required_parts, default_options, route_spec, full_url, arguments);
      };
      path_fn.required_params = required_parts;
      path_fn.toString = function() {
        return Utils.build_path_spec(route_spec);
      };
      return path_fn;
    },
    route_url: function(route_defaults) {
      var hostname, port, protocol, subdomain;
      if (typeof route_defaults === 'string') {
        return route_defaults;
      }
      hostname = route_defaults.host || Utils.current_host();
      if (!hostname) {
        return '';
      }
      subdomain = route_defaults.subdomain ? route_defaults.subdomain + '.' : '';
      protocol = route_defaults.protocol || Utils.current_protocol();
      port = route_defaults.port || (!route_defaults.host ? Utils.current_port() : void 0);
      port = port ? ":" + port : '';
      return protocol + "://" + subdomain + hostname + port;
    },
    has_location: function() {
      return (typeof window !== "undefined" && window !== null ? window.location : void 0) != null;
    },
    current_host: function() {
      if (this.has_location()) {
        return window.location.hostname;
      } else {
        return null;
      }
    },
    current_protocol: function() {
      if (this.has_location() && window.location.protocol !== '') {
        return window.location.protocol.replace(/:$/, '');
      } else {
        return 'http';
      }
    },
    current_port: function() {
      if (this.has_location() && window.location.port !== '') {
        return window.location.port;
      } else {
        return '';
      }
    },
    _classToTypeCache: null,
    _classToType: function() {
      var j, len, name, ref;
      if (this._classToTypeCache != null) {
        return this._classToTypeCache;
      }
      this._classToTypeCache = {};
      ref = "Boolean Number String Function Array Date RegExp Object Error".split(" ");
      for (j = 0, len = ref.length; j < len; j++) {
        name = ref[j];
        this._classToTypeCache["[object " + name + "]"] = name.toLowerCase();
      }
      return this._classToTypeCache;
    },
    get_object_type: function(obj) {
      if (root.jQuery && (root.jQuery.type != null)) {
        return root.jQuery.type(obj);
      }
      if (obj == null) {
        return "" + obj;
      }
      if (typeof obj === "object" || typeof obj === "function") {
        return this._classToType()[Object.prototype.toString.call(obj)] || "object";
      } else {
        return typeof obj;
      }
    },
    indexOf: function(array, element) {
      if (Array.prototype.indexOf) {
        return array.indexOf(element);
      } else {
        return this.indexOfImplementation(array, element);
      }
    },
    indexOfImplementation: function(array, element) {
      var el, i, j, len, result;
      result = -1;
      for (i = j = 0, len = array.length; j < len; i = ++j) {
        el = array[i];
        if (el === element) {
          result = i;
        }
      }
      return result;
    },
    namespace: function(root, namespace, routes) {
      var index, j, len, part, parts;
      parts = namespace ? namespace.split(".") : [];
      if (parts.length === 0) {
        return routes;
      }
      for (index = j = 0, len = parts.length; j < len; index = ++j) {
        part = parts[index];
        if (index < parts.length - 1) {
          root = (root[part] || (root[part] = {}));
        } else {
          return root[part] = routes;
        }
      }
    },
    configure: function(new_config) {
      return this.configuration = this.merge(this.configuration, new_config);
    },
    config: function() {
      return this.clone(this.configuration);
    },
    make: function() {
      var routes;
      routes = {
// about_us => /about-us(.:format)
  // function(options)
  about_us_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"about-us",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
about_us_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"about-us",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// accessibility => /accessibility(.:format)
  // function(options)
  accessibility_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"accessibility",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
accessibility_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"accessibility",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// acquisitions => /landing(.:format)
  // function(options)
  acquisitions_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"landing",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
acquisitions_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"landing",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// acquisitions_deal => /landing/deals/:id(.:format)
  // function(id, options)
  acquisitions_deal_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"landing",false],[2,[7,"/",false],[2,[6,"deals",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
acquisitions_deal_url: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"landing",false],[2,[7,"/",false],[2,[6,"deals",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]], true),
// ad_choices => /ad-choices(.:format)
  // function(options)
  ad_choices_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"ad-choices",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
ad_choices_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"ad-choices",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// add_brad_acquisitions => /landing/add-brad(.:format)
  // function(options)
  add_brad_acquisitions_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"landing",false],[2,[7,"/",false],[2,[6,"add-brad",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
add_brad_acquisitions_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"landing",false],[2,[7,"/",false],[2,[6,"add-brad",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// advertise => /about-us/advertise(.:format)
  // function(options)
  advertise_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"about-us",false],[2,[7,"/",false],[2,[6,"advertise",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
advertise_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"about-us",false],[2,[7,"/",false],[2,[6,"advertise",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// alexa => /oauth/alexa(.:format)
  // function(options)
  alexa_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"oauth",false],[2,[7,"/",false],[2,[6,"alexa",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
alexa_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"oauth",false],[2,[7,"/",false],[2,[6,"alexa",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// all_merchants => /stores/all(.:format)
  // function(options)
  all_merchants_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"stores",false],[2,[7,"/",false],[2,[6,"all",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
all_merchants_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"stores",false],[2,[7,"/",false],[2,[6,"all",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// api_interests => /api/interests(.:format)
  // function(options)
  api_interests_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"interests",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
api_interests_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"interests",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// api_my_deals => /api/my-deals(.:format)
  // function(options)
  api_my_deals_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"my-deals",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
api_my_deals_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"my-deals",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// api_search_events => /api/search_events(.:format)
  // function(options)
  api_search_events_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"search_events",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
api_search_events_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"search_events",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// api_searches => /api/search(.:format)
  // function(options)
  api_searches_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"search",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
api_searches_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"search",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// api_user_interests => /api/users/interests(.:format)
  // function(options)
  api_user_interests_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[6,"interests",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
api_user_interests_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[6,"interests",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]], true),
// app => /app(.:format)
  // function(options)
  app_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"app",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
app_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"app",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// appboy_unsubscribe => /appboy/unsubscribe(.:format)
  // function(options)
  appboy_unsubscribe_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"appboy",false],[2,[7,"/",false],[2,[6,"unsubscribe",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
appboy_unsubscribe_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"appboy",false],[2,[7,"/",false],[2,[6,"unsubscribe",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// authorize => /oauth/authorize(.:format)
  // function(options)
  authorize_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"oauth",false],[2,[7,"/",false],[2,[6,"authorize",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
authorize_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"oauth",false],[2,[7,"/",false],[2,[6,"authorize",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// blog => /blog/:slug(.:format)
  // function(slug, options)
  blog_path: Utils.route([["slug",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[3,"slug",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
blog_url: Utils.route([["slug",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[3,"slug",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// blog_category => /blog/category/:slug(.:format)
  // function(slug, options)
  blog_category_path: Utils.route([["slug",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"category",false],[2,[7,"/",false],[2,[3,"slug",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
blog_category_url: Utils.route([["slug",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[2,[7,"/",false],[2,[6,"category",false],[2,[7,"/",false],[2,[3,"slug",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]], true),
// blogs => /blog(.:format)
  // function(options)
  blogs_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
blogs_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"blog",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// careers => /about-us/careers(.:format)
  // function(options)
  careers_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"about-us",false],[2,[7,"/",false],[2,[6,"careers",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
careers_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"about-us",false],[2,[7,"/",false],[2,[6,"careers",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// cares => /cares(.:format)
  // function(options)
  cares_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"cares",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
cares_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"cares",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// categories => /categories(.:format)
  // function(options)
  categories_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"categories",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
categories_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"categories",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// category => /categories/*category_slug/:item_type(.:format)
  // function(category_slug, item_type, options)
  category_path: Utils.route([["category_slug",true],["item_type",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"categories",false],[2,[7,"/",false],[2,[5,[3,"category_slug",false],false],[2,[7,"/",false],[2,[3,"item_type",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
category_url: Utils.route([["category_slug",true],["item_type",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"categories",false],[2,[7,"/",false],[2,[5,[3,"category_slug",false],false],[2,[7,"/",false],[2,[3,"item_type",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]], true),
// category_feed => /categories/:category_slug(.:format)
  // function(category_slug, options)
  category_feed_path: Utils.route([["category_slug",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"categories",false],[2,[7,"/",false],[2,[3,"category_slug",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
category_feed_url: Utils.route([["category_slug",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"categories",false],[2,[7,"/",false],[2,[3,"category_slug",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// ccpa => /ccpa(.:format)
  // function(options)
  ccpa_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"ccpa",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
ccpa_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"ccpa",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// ccpa_notice => /ccpa-notice-at-collection(.:format)
  // function(options)
  ccpa_notice_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"ccpa-notice-at-collection",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
ccpa_notice_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"ccpa-notice-at-collection",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// collection => /collections/:slug(.:format)
  // function(slug, options)
  collection_path: Utils.route([["slug",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"collections",false],[2,[7,"/",false],[2,[3,"slug",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
collection_url: Utils.route([["slug",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"collections",false],[2,[7,"/",false],[2,[3,"slug",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// comment => /comments/:id(.:format)
  // function(id, options)
  comment_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"comments",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
comment_url: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"comments",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// comment_policy => /comment-policy(.:format)
  // function(options)
  comment_policy_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"comment-policy",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
comment_policy_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"comment-policy",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// comments => /comments(.:format)
  // function(options)
  comments_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"comments",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
comments_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"comments",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// contact_us => /contact-us(.:format)
  // function(options)
  contact_us_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"contact-us",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
contact_us_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"contact-us",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// contact_us_notify => /contact_us/notify(.:format)
  // function(options)
  contact_us_notify_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"contact_us",false],[2,[7,"/",false],[2,[6,"notify",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
contact_us_notify_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"contact_us",false],[2,[7,"/",false],[2,[6,"notify",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// coupon => /coupons/:id(.:format)
  // function(id, options)
  coupon_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"coupons",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
coupon_url: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"coupons",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// coupons => /coupons(.:format)
  // function(options)
  coupons_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"coupons",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
coupons_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"coupons",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// coupons_merchant => /coupons/:merchant_id(.:format)
  // function(merchant_id, options)
  coupons_merchant_path: Utils.route([["merchant_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"coupons",false],[2,[7,"/",false],[2,[3,"merchant_id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
coupons_merchant_url: Utils.route([["merchant_id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"coupons",false],[2,[7,"/",false],[2,[3,"merchant_id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// credit_cards => /categories/credit-cards(.:format)
  // function(options)
  credit_cards_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"categories",false],[2,[7,"/",false],[2,[6,"credit-cards",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
credit_cards_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"categories",false],[2,[7,"/",false],[2,[6,"credit-cards",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// cvs_terms => /cvs-terms(.:format)
  // function(options)
  cvs_terms_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"cvs-terms",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
cvs_terms_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"cvs-terms",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// cyber_monday => /cyber-monday(.:format)
  // function(options)
  cyber_monday_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"cyber-monday",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
cyber_monday_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"cyber-monday",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// daa_acquisitions => /landing/daa(.:format)
  // function(options)
  daa_acquisitions_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"landing",false],[2,[7,"/",false],[2,[6,"daa",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
daa_acquisitions_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"landing",false],[2,[7,"/",false],[2,[6,"daa",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// deal => /deals/:id(.:format)
  // function(id, options)
  deal_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"deals",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
deal_url: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"deals",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// deal_alerts_landing => /deal-alerts(.:format)
  // function(options)
  deal_alerts_landing_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"deal-alerts",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
deal_alerts_landing_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"deal-alerts",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// deals => /deals(.:format)
  // function(options)
  deals_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"deals",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
deals_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"deals",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// deals_count_deals => /deals/count(.:format)
  // function(options)
  deals_count_deals_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"deals",false],[2,[7,"/",false],[2,[6,"count",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
deals_count_deals_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"deals",false],[2,[7,"/",false],[2,[6,"count",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// do_not_sell => /do-not-sell-my-personal-information(.:format)
  // function(options)
  do_not_sell_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"do-not-sell-my-personal-information",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
do_not_sell_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"do-not-sell-my-personal-information",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// email_preferences_user => /me/email-preferences(.:format)
  // function(options)
  email_preferences_user_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email-preferences",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
email_preferences_user_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email-preferences",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// engagement => /engagements/:id(.:format)
  // function(id, options)
  engagement_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"engagements",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
engagement_url: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"engagements",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// engagements => /engagements(.:format)
  // function(options)
  engagements_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"engagements",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
engagements_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"engagements",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// engagements_users => /users/engagements(.:format)
  // function(options)
  engagements_users_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[6,"engagements",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
engagements_users_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[6,"engagements",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// event => /events/:slug(.:format)
  // function(slug, options)
  event_path: Utils.route([["slug",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"events",false],[2,[7,"/",false],[2,[3,"slug",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
event_url: Utils.route([["slug",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"events",false],[2,[7,"/",false],[2,[3,"slug",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// exclusive_deals => /exclusives(.:format)
  // function(options)
  exclusive_deals_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"exclusives",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
exclusive_deals_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"exclusives",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// faq => /faq(.:format)
  // function(options)
  faq_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"faq",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
faq_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"faq",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// feed => /feeds/:id(.:format)
  // function(id, options)
  feed_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"feeds",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
feed_url: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"feeds",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// google_index => /google(.:format)
  // function(options)
  google_index_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"google",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
google_index_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"google",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// guide => /guides/:id(.:format)
  // function(id, options)
  guide_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"guides",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
guide_url: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"guides",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// guides => /guides(.:format)
  // function(options)
  guides_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"guides",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
guides_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"guides",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// healthcheck_index => /healthcheck(.:format)
  // function(options)
  healthcheck_index_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"healthcheck",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
healthcheck_index_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"healthcheck",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// help_center => /help-center(.:format)
  // function(options)
  help_center_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"help-center",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
help_center_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"help-center",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// help_center_notify => /help_center/notify(.:format)
  // function(options)
  help_center_notify_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"help_center",false],[2,[7,"/",false],[2,[6,"notify",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
help_center_notify_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"help_center",false],[2,[7,"/",false],[2,[6,"notify",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// how_we_work => /how-we-work(.:format)
  // function(options)
  how_we_work_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"how-we-work",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
how_we_work_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"how-we-work",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// insurance_category => /categories/insurance(.:format)
  // function(options)
  insurance_category_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"categories",false],[2,[7,"/",false],[2,[6,"insurance",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
insurance_category_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"categories",false],[2,[7,"/",false],[2,[6,"insurance",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// kohls_single_use_terms => /kohls-single-use-terms(.:format)
  // function(options)
  kohls_single_use_terms_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"kohls-single-use-terms",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
kohls_single_use_terms_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"kohls-single-use-terms",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// loving_the_locals => /loving-the-locals(.:format)
  // function(options)
  loving_the_locals_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"loving-the-locals",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
loving_the_locals_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"loving-the-locals",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// merchant => /stores/:id(.:format)
  // function(id, options)
  merchant_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"stores",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
merchant_url: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"stores",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// merchants => /stores(.:format)
  // function(options)
  merchants_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"stores",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
merchants_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"stores",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// merchants_by_character => /stores/all/:character(.:format)
  // function(character, options)
  merchants_by_character_path: Utils.route([["character",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"stores",false],[2,[7,"/",false],[2,[6,"all",false],[2,[7,"/",false],[2,[3,"character",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
merchants_by_character_url: Utils.route([["character",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"stores",false],[2,[7,"/",false],[2,[6,"all",false],[2,[7,"/",false],[2,[3,"character",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]], true),
// mobile_acquisitions => /landing/mobile(.:format)
  // function(options)
  mobile_acquisitions_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"landing",false],[2,[7,"/",false],[2,[6,"mobile",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
mobile_acquisitions_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"landing",false],[2,[7,"/",false],[2,[6,"mobile",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// my_deals => /my-deals(.:format)
  // function(options)
  my_deals_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"my-deals",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
my_deals_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"my-deals",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// native_app_acquisitions => /landing/native-app(.:format)
  // function(options)
  native_app_acquisitions_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"landing",false],[2,[7,"/",false],[2,[6,"native-app",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
native_app_acquisitions_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"landing",false],[2,[7,"/",false],[2,[6,"native-app",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// new_password_user => /me/password-reset(.:format)
  // function(options)
  new_password_user_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"password-reset",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
new_password_user_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"password-reset",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// newest_deals => /newest-deals(.:format)
  // function(options)
  newest_deals_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"newest-deals",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
newest_deals_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"newest-deals",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// our_brand => /our-brand(.:format)
  // function(options)
  our_brand_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"our-brand",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
our_brand_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"our-brand",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// pandora_single_use_terms => /pandora-single-use-terms(.:format)
  // function(options)
  pandora_single_use_terms_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"pandora-single-use-terms",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
pandora_single_use_terms_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"pandora-single-use-terms",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// pattern_library => /pattern-library(.:format)
  // function(options)
  pattern_library_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"pattern-library",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
pattern_library_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"pattern-library",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// pause_subscription => /subscriptions/:id/pause(.:format)
  // function(id, options)
  pause_subscription_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"subscriptions",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"pause",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
pause_subscription_url: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"subscriptions",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"pause",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]], true),
// personalized_api_deals => /api/deals/personalized(.:format)
  // function(options)
  personalized_api_deals_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"deals",false],[2,[7,"/",false],[2,[6,"personalized",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
personalized_api_deals_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"deals",false],[2,[7,"/",false],[2,[6,"personalized",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]], true),
// placement => /placements/:id(.:format)
  // function(id, options)
  placement_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"placements",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
placement_url: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"placements",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// popular_merchants => /stores/popular_merchants(.:format)
  // function(options)
  popular_merchants_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"stores",false],[2,[7,"/",false],[2,[6,"popular_merchants",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
popular_merchants_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"stores",false],[2,[7,"/",false],[2,[6,"popular_merchants",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// privacy => /privacy(.:format)
  // function(options)
  privacy_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"privacy",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
privacy_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"privacy",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// recommended_deal => /deals/:id/recommended(.:format)
  // function(id, options)
  recommended_deal_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"deals",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"recommended",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
recommended_deal_url: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"deals",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"recommended",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]], true),
// related_api_queries => /api/queries/related(.:format)
  // function(options)
  related_api_queries_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"queries",false],[2,[7,"/",false],[2,[6,"related",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
related_api_queries_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"api",false],[2,[7,"/",false],[2,[6,"queries",false],[2,[7,"/",false],[2,[6,"related",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]], true),
// related_deal => /deals/:id/related(.:format)
  // function(id, options)
  related_deal_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"deals",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"related",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
related_deal_url: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"deals",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"related",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]], true),
// request_reset_user_passwords => /me/password/request-reset(.:format)
  // function(options)
  request_reset_user_passwords_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"password",false],[2,[7,"/",false],[2,[6,"request-reset",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
request_reset_user_passwords_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"password",false],[2,[7,"/",false],[2,[6,"request-reset",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]], true),
// root => /
  // function(options)
  root_path: Utils.route([], {}, [7,"/",false]),
root_url: Utils.route([], {}, [7,"/",false], true),
// saved_items_user => /me/saved-items(.:format)
  // function(options)
  saved_items_user_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"saved-items",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
saved_items_user_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"saved-items",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// searches => /search(.:format)
  // function(options)
  searches_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"search",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
searches_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"search",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// send_request_reset_user_passwords => /me/password/request-reset(.:format)
  // function(options)
  send_request_reset_user_passwords_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"password",false],[2,[7,"/",false],[2,[6,"request-reset",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
send_request_reset_user_passwords_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"password",false],[2,[7,"/",false],[2,[6,"request-reset",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]], true),
// sessions => /sessions(.:format)
  // function(options)
  sessions_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"sessions",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
sessions_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"sessions",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// share => /email/share(.:format)
  // function(options)
  share_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[6,"share",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
share_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[6,"share",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// subscription => /subscriptions/:id(.:format)
  // function(id, options)
  subscription_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"subscriptions",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
subscription_url: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"subscriptions",false],[2,[7,"/",false],[2,[3,"id",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// subscriptions => /subscriptions(.:format)
  // function(options)
  subscriptions_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"subscriptions",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
subscriptions_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"subscriptions",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// subscriptions_users => /users/subscriptions(.:format)
  // function(options)
  subscriptions_users_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[6,"subscriptions",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
subscriptions_users_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[2,[7,"/",false],[2,[6,"subscriptions",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// terms => /terms-of-use(.:format)
  // function(options)
  terms_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"terms-of-use",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
terms_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"terms-of-use",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// topics => /topics(.:format)
  // function(options)
  topics_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"topics",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
topics_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"topics",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// travel => /travel(.:format)
  // function(options)
  travel_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"travel",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
travel_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"travel",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// unsubscribe_subscription => /subscriptions/:id/unsubscribe(.:format)
  // function(id, options)
  unsubscribe_subscription_path: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"subscriptions",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"unsubscribe",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
unsubscribe_subscription_url: Utils.route([["id",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"subscriptions",false],[2,[7,"/",false],[2,[3,"id",false],[2,[7,"/",false],[2,[6,"unsubscribe",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]], true),
// unsubscribe_subscriptions => /subscriptions/unsubscribe(.:format)
  // function(options)
  unsubscribe_subscriptions_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"subscriptions",false],[2,[7,"/",false],[2,[6,"unsubscribe",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
unsubscribe_subscriptions_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"subscriptions",false],[2,[7,"/",false],[2,[6,"unsubscribe",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// unsubscribe_user => /me/unsubscribe(.:format)
  // function(options)
  unsubscribe_user_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"unsubscribe",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
unsubscribe_user_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"unsubscribe",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// user => /me(.:format)
  // function(options)
  user_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
user_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// user_email_check => /me/email/:md5/check(.:format)
  // function(md5, options)
  user_email_check_path: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"check",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
user_email_check_url: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"check",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]], true),
// user_email_confirm => /me/email/:md5/confirm(.:format)
  // function(md5, options)
  user_email_confirm_path: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"confirm",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
user_email_confirm_url: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"confirm",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]], true),
// user_email_opt_out_newsletter => /me/email/:md5/opt-out-newsletter(.:format)
  // function(md5, options)
  user_email_opt_out_newsletter_path: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"opt-out-newsletter",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
user_email_opt_out_newsletter_url: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"opt-out-newsletter",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]], true),
// user_email_opt_out_promotional => /me/email/:md5/opt-out-promotional(.:format)
  // function(md5, options)
  user_email_opt_out_promotional_path: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"opt-out-promotional",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
user_email_opt_out_promotional_url: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"opt-out-promotional",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]], true),
// user_email_opt_out_recommended => /me/email/:md5/opt-out-recommended(.:format)
  // function(md5, options)
  user_email_opt_out_recommended_path: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"opt-out-recommended",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
user_email_opt_out_recommended_url: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"opt-out-recommended",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]], true),
// user_email_preferences => /me/email/:md5/preferences(.:format)
  // function(md5, options)
  user_email_preferences_path: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"preferences",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
user_email_preferences_url: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"preferences",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]], true),
// user_email_resend_confirm => /me/email/:md5/resend_confirm(.:format)
  // function(md5, options)
  user_email_resend_confirm_path: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"resend_confirm",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
user_email_resend_confirm_url: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"resend_confirm",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]], true),
// user_email_send_confirmation => /me/email/:md5/send_confirmation(.:format)
  // function(md5, options)
  user_email_send_confirmation_path: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"send_confirmation",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
user_email_send_confirmation_url: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"send_confirmation",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]], true),
// user_email_set_frequency_twice_weekly => /me/email/:md5/set-frequency-twice-weekly(.:format)
  // function(md5, options)
  user_email_set_frequency_twice_weekly_path: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"set-frequency-twice-weekly",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
user_email_set_frequency_twice_weekly_url: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"set-frequency-twice-weekly",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]], true),
// user_email_set_frequency_weekly => /me/email/:md5/set-frequency-weekly(.:format)
  // function(md5, options)
  user_email_set_frequency_weekly_path: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"set-frequency-weekly",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
user_email_set_frequency_weekly_url: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"set-frequency-weekly",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]], true),
// user_email_subscriptions => /me/email/:md5/subscriptions(.:format)
  // function(md5, options)
  user_email_subscriptions_path: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"subscriptions",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]]),
user_email_subscriptions_url: Utils.route([["md5",true],["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"email",false],[2,[7,"/",false],[2,[3,"md5",false],[2,[7,"/",false],[2,[6,"subscriptions",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]]], true),
// user_passwords => /me/password(.:format)
  // function(options)
  user_passwords_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"password",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
user_passwords_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"me",false],[2,[7,"/",false],[2,[6,"password",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// user_profiles => /user_profiles(.:format)
  // function(options)
  user_profiles_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"user_profiles",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
user_profiles_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"user_profiles",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// users => /users(.:format)
  // function(options)
  users_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[1,[2,[8,".",false],[3,"format",false]],false]]]),
users_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"users",false],[1,[2,[8,".",false],[3,"format",false]],false]]], true),
// video_games_category => /categories/electronics/video-games(.:format)
  // function(options)
  video_games_category_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"categories",false],[2,[7,"/",false],[2,[6,"electronics",false],[2,[7,"/",false],[2,[6,"video-games",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]]),
video_games_category_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"categories",false],[2,[7,"/",false],[2,[6,"electronics",false],[2,[7,"/",false],[2,[6,"video-games",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]]], true),
// womens_tech_accelerator => /about-us/womens-tech-accelerator(.:format)
  // function(options)
  womens_tech_accelerator_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"about-us",false],[2,[7,"/",false],[2,[6,"womens-tech-accelerator",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
womens_tech_accelerator_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"about-us",false],[2,[7,"/",false],[2,[6,"womens-tech-accelerator",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true),
// womens_tech_accelerator_faq => /about-us/womens-tech-accelerator-faq(.:format)
  // function(options)
  womens_tech_accelerator_faq_path: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"about-us",false],[2,[7,"/",false],[2,[6,"womens-tech-accelerator-faq",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]]),
womens_tech_accelerator_faq_url: Utils.route([["format",false]], {}, [2,[7,"/",false],[2,[6,"about-us",false],[2,[7,"/",false],[2,[6,"womens-tech-accelerator-faq",false],[1,[2,[8,".",false],[3,"format",false]],false]]]]], true)}
;
      routes.configure = function(config) {
        return Utils.configure(config);
      };
      routes.config = function() {
        return Utils.config();
      };
      Object.defineProperty(routes, 'defaults', {
        get: function() {
          throw new Error(null + ".defaults is removed. Use " + null + ".configure() instead.");
        },
        set: function(value) {}
      });
      routes.default_serializer = function(object, prefix) {
        return Utils.default_serializer(object, prefix);
      };
      return Utils.namespace(root, null, routes);
    }
  };

  result = Utils.make();

  if (typeof define === "function" && define.amd) {
    define([], function() {
      return result;
    });
  }

  return result;

}).call(this);

